module.exports = __webpack_public_path__ + "commont.4d881f35.png";